import { render, staticRenderFns } from "./SummaryInfoServices.vue?vue&type=template&id=311b7e66&"
import script from "./SummaryInfoServices.vue?vue&type=script&lang=ts&"
export * from "./SummaryInfoServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports